











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {SaraivaCnpjDisponivel} from '@/model/resource/SaraivaCnpjDisponivel'
import {SaraivaCnpjDisponivelCollection} from '@/model/collection/SaraivaCnpjDisponivelCollection'
import {ListSaraivaCnpjDisponivelSchema} from '@/schema/resource/SaraivaCnpjDisponivel/ListSaraivaCnpjDisponivelSchema'
import {CsvSaraivaCnpjDisponivelSchema} from '@/schema/resource/SaraivaCnpjDisponivel/CsvSaraivaCnpjDisponivelSchema'

@Component
export default class ListSaraivaCnpjDisponivelView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListSaraivaCnpjDisponivelSchema()
  collection = new SaraivaCnpjDisponivelCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: SaraivaCnpjDisponivel) {
    Helper.pushByName('editSaraivaCnpjDisponivel', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new SaraivaCnpjDisponivelCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvSaraivaCnpjDisponivel()
    new CsvSaraivaCnpjDisponivelSchema().downloadCsv(csv.all())
  }
}
